import React from "react";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { ADD_CONTACT_DIRECTORY } from "../constant";
import Input from "../../../component-lib/Atoms/Input/Input";
import ContactInput from "../../../component-lib/Atoms/Input/ContactInput";
import { normalizeContactNumber } from "../../../utils/phoneNumberFormatter";
import Button from "../../../component-lib/Molecules/button/Button";
import { TEXT_CONSTANTS } from "../../../utils/text-constants/textConstants";
import { VALIDATION_CONSTANTS } from "../../../utils/validation-constants/validationConstants";
import BootstrapDialog from "../../../utils/bootstrap-dialog-style/BootstrapDialog";
import SelectDropdown from "../../../component-lib/Atoms/Select/Select";

interface AddDepartmentDialogProps {
  isOpen: boolean;
  label: string;
  defaultSelectedData: { isEdit: boolean; data: any };
  handleData: (data: any) => void;
  handleClose: () => void;
}

export default function AddContactDirectory({
  isOpen = false,
  label = "Your label here",
  defaultSelectedData = {
    isEdit: false,
    data: {},
  },
  handleClose,
  handleData,
}: AddDepartmentDialogProps) {
  const validationSchema = Yup.object().shape({
    [ADD_CONTACT_DIRECTORY?.HOSPITAL_NAME]: Yup.string()
      .matches(VALIDATION_CONSTANTS.NAME, "Name can only contain characters")
      .required("Name is required"),
    // [ADD_CONTACT_DIRECTORY?.TYPE]: Yup.string().required("Type is required"),
    [ADD_CONTACT_DIRECTORY?.ADDRESS]: Yup.string().required(
      "Address is required"
    ),
    [ADD_CONTACT_DIRECTORY?.SPECIALTIES]: Yup.string().required(
      "Specialties is required"
    ),
    [ADD_CONTACT_DIRECTORY?.CONTACT_NUMBER]: Yup.string()
      .matches(VALIDATION_CONSTANTS.CONTACT_NUMBER, "Invalid contact number")
      .required("Contact number is required"),
    [ADD_CONTACT_DIRECTORY?.EMAIL]: Yup.string().matches(
      VALIDATION_CONSTANTS.EMAIL,
      "Invalid email"
    ),
  });

  const gridTwoColumnStyle = {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
  };

  return (
    <BootstrapDialog
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          handleClose();
        }
      }}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
    >
      <Formik
        initialValues={{
          [ADD_CONTACT_DIRECTORY?.HOSPITAL_NAME]: `${defaultSelectedData?.isEdit ? defaultSelectedData?.data?.name : ""}`,
          // [ADD_CONTACT_DIRECTORY?.TYPE]: `${defaultSelectedData?.isEdit ? defaultSelectedData?.data?.type : ""}`,
          [ADD_CONTACT_DIRECTORY?.ADDRESS]: `${defaultSelectedData?.isEdit ? defaultSelectedData?.data?.address : ""}`,
          [ADD_CONTACT_DIRECTORY?.SPECIALTIES]: `${defaultSelectedData?.isEdit ? defaultSelectedData?.data?.specialties : ""}`,
          [ADD_CONTACT_DIRECTORY?.CONTACT_NUMBER]: normalizeContactNumber(
            defaultSelectedData?.isEdit
              ? defaultSelectedData?.data?.contactNumber
              : ""
          ),
          [ADD_CONTACT_DIRECTORY?.EMAIL]: `${
            defaultSelectedData?.isEdit
              ? defaultSelectedData?.data?.email || ""
              : ""
          }`,
        }}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={(values, { setSubmitting }) => {
          try {
            // getFormData(values);
            handleData(values);
          } catch (error) {
            console.log(error);
          } finally {
            setSubmitting(false); // Reset submitting state
          }
        }}
      >
        {({
          errors,
          values,
          touched,
          isValid,
          dirty,
          setFieldValue,
          handleBlur,
          handleSubmit,
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <DialogTitle
                sx={{
                  m: 0,
                  p: 2,
                  fontWeight: 600,
                  fontSize: "18px",
                  fontFamily: "inter",
                }}
                id="customized-dialog-title"
              >
                {label}
              </DialogTitle>
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={(theme) => ({
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: theme.palette.grey[500],
                })}
              >
                <CloseIcon />
              </IconButton>
              <hr />
              {/* MAIN CONTENT */}
              <DialogContent>
                <div>
                  {/* HOSPITAL NAME TEXTFIELD */}
                  <div className="pt-6 w-[49%]">
                    <Input
                      textFieldLabel="Enter Name"
                      // placeholder="Enter Department ID"
                      size="small"
                      name={ADD_CONTACT_DIRECTORY.HOSPITAL_NAME}
                      value={values[ADD_CONTACT_DIRECTORY.HOSPITAL_NAME]}
                      onChangeCb={(e) => {
                        setFieldValue(
                          ADD_CONTACT_DIRECTORY.HOSPITAL_NAME,
                          e.target.value
                        );
                      }}
                      onBlur={handleBlur}
                      error={
                        touched[ADD_CONTACT_DIRECTORY.HOSPITAL_NAME] &&
                        Boolean(errors[ADD_CONTACT_DIRECTORY.HOSPITAL_NAME])
                      }
                      helperText={
                        touched[ADD_CONTACT_DIRECTORY.HOSPITAL_NAME]
                          ? errors[ADD_CONTACT_DIRECTORY.HOSPITAL_NAME]
                          : undefined
                      }
                    />
                    {/* <SelectDropdown
                      label="Enter Type"
                      // disabled={defaultRoleData?.id}
                      value={values[ADD_CONTACT_DIRECTORY.TYPE]}
                      options={TYPES}
                      onChangeCb={(e) =>
                        setFieldValue(
                          ADD_CONTACT_DIRECTORY.TYPE,
                          e.target.value
                        )
                      }
                      error={
                        touched[ADD_CONTACT_DIRECTORY.TYPE] &&
                        Boolean(errors[ADD_CONTACT_DIRECTORY.TYPE])
                      }
                      helperText={
                        touched[ADD_CONTACT_DIRECTORY.TYPE]
                          ? errors[ADD_CONTACT_DIRECTORY.TYPE]
                          : undefined
                      }
                    /> */}
                  </div>

                  {/* HOSPITAL ADDRESS TEXTFIELD */}
                  <div className="pt-6">
                    <Input
                      textFieldLabel="Enter Address"
                      // placeholder="Enter Department ID"
                      size="small"
                      name={ADD_CONTACT_DIRECTORY.ADDRESS}
                      value={values[ADD_CONTACT_DIRECTORY.ADDRESS]}
                      onChangeCb={(e) => {
                        setFieldValue(
                          ADD_CONTACT_DIRECTORY.ADDRESS,
                          e.target.value
                        );
                      }}
                      onBlur={handleBlur}
                      error={
                        touched[ADD_CONTACT_DIRECTORY.ADDRESS] &&
                        Boolean(errors[ADD_CONTACT_DIRECTORY.ADDRESS])
                      }
                      helperText={
                        touched[ADD_CONTACT_DIRECTORY.ADDRESS]
                          ? errors[ADD_CONTACT_DIRECTORY.ADDRESS]
                          : undefined
                      }
                    />
                  </div>

                  {/* SPECIALTIES AND CONTACT NUMBER TEXTFIELD */}
                  <div className="pt-6" style={gridTwoColumnStyle}>
                    <Input
                      textFieldLabel="Enter Specialties"
                      // placeholder="Enter Department ID"
                      size="small"
                      name={ADD_CONTACT_DIRECTORY.SPECIALTIES}
                      value={values[ADD_CONTACT_DIRECTORY.SPECIALTIES]}
                      onChangeCb={(e) => {
                        setFieldValue(
                          ADD_CONTACT_DIRECTORY.SPECIALTIES,
                          e.target.value
                        );
                      }}
                      onBlur={handleBlur}
                      error={
                        touched[ADD_CONTACT_DIRECTORY.SPECIALTIES] &&
                        Boolean(errors[ADD_CONTACT_DIRECTORY.SPECIALTIES])
                      }
                      helperText={
                        touched[ADD_CONTACT_DIRECTORY.SPECIALTIES]
                          ? errors[ADD_CONTACT_DIRECTORY.SPECIALTIES]
                          : undefined
                      }
                    />
                    <ContactInput
                      textFieldLabel="Enter Contact Number"
                      name={ADD_CONTACT_DIRECTORY.CONTACT_NUMBER}
                      value={values[ADD_CONTACT_DIRECTORY.CONTACT_NUMBER]}
                      onChangeCb={(value) => {
                        setFieldValue(
                          ADD_CONTACT_DIRECTORY.CONTACT_NUMBER,
                          value
                        );
                      }}
                      onBlur={handleBlur}
                      size="small"
                      error={
                        touched[ADD_CONTACT_DIRECTORY.CONTACT_NUMBER] &&
                        Boolean(errors[ADD_CONTACT_DIRECTORY.CONTACT_NUMBER])
                      }
                      helperText={
                        touched[ADD_CONTACT_DIRECTORY.CONTACT_NUMBER]
                          ? errors[ADD_CONTACT_DIRECTORY.CONTACT_NUMBER]
                          : undefined
                      }
                      isContactNumber={true}
                    />
                  </div>

                  {/* EMAIL TEXTFIELD */}
                  <div className="pt-6 w-[49%]">
                    <Input
                      textFieldLabel="Enter Email"
                      type="text"
                      size="small"
                      name={ADD_CONTACT_DIRECTORY.EMAIL}
                      value={values[ADD_CONTACT_DIRECTORY.EMAIL]}
                      onChangeCb={(e) => {
                        setFieldValue(
                          ADD_CONTACT_DIRECTORY.EMAIL,
                          e.target.value
                        );
                      }}
                      onBlur={handleBlur}
                      error={
                        touched[ADD_CONTACT_DIRECTORY.EMAIL] &&
                        Boolean(errors[ADD_CONTACT_DIRECTORY.EMAIL])
                      }
                      helperText={
                        touched[ADD_CONTACT_DIRECTORY.EMAIL] &&
                        errors[ADD_CONTACT_DIRECTORY.EMAIL]
                          ? String(errors[ADD_CONTACT_DIRECTORY.EMAIL])
                          : undefined
                      }
                    />
                  </div>
                </div>
              </DialogContent>

              {/* ACTION BUTTON */}
              <DialogActions style={{ padding: "24px" }}>
                <Button
                  label={TEXT_CONSTANTS?.CANCEL}
                  variant="outlined"
                  onClickCb={() => {
                    handleClose();
                  }}
                  style={{
                    width: "120px",
                    height: "44px",
                    padding: "12px 20px",
                    fontSize: "16px",
                    backgroundColor: "white",
                    border: "none",
                    color: "#393939",
                  }}
                />
                <Button
                  type="submit"
                  label={TEXT_CONSTANTS?.SAVE}
                  variant="contained"
                  onClickCb={() => {}}
                  style={{
                    padding: "8px 55px",
                    fontSize: "16px",
                  }}
                />
              </DialogActions>
            </Form>
          );
        }}
      </Formik>
    </BootstrapDialog>
  );
}
